import { Form } from "react-bootstrap"

interface IntegrationTypeSelectProps {
  value: string
  disabled?: boolean
  options?: { value: string; label: string }[]
  onChange: (integrationType: string) => void
}

const DEFAULT_OPTIONS = [
  { value: "", label: "Select" },
  { value: "Default", label: "Default" },
  { value: "EMBEDDED", label: "EMBEDDED" },
]

function IntegrationTypeSelect({
  value,
  disabled = false,
  options = DEFAULT_OPTIONS,
  onChange,
}: IntegrationTypeSelectProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)

  return (
    <Form.Control
      as="select"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      aria-label="Integration type selector"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Control>
  )
}

export default IntegrationTypeSelect
